import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SoaTxnDescUpdateModalUI from './SoaTxnDescUpdateModalUI'

class SoaTxnDescUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      txnDate: '',
      txnDateError: null,
      description: '',
      descriptionError: null,
      dsraCurrent: '',
      dsraCurrentError: null,
      dsraAmount: '',
      dsraAmountError: null,
      osPrincipal: '',
      osPrincipalError: null,
      osLoan: '',
      osLoanError: null,
      osBalance: '',
      osBalanceError: null,
      escrowBalance: '',
      escrowBalanceError: null
    }
  }

  render() {
    return (
      <SoaTxnDescUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        txnDate={this.state.txnDate}
        onTxnDateChange={(event) => this.setState({ txnDate: event.target.value })}
        txnDateError={this.state.txnDateError}
        setTxnDateError={(error) => { this.setState({ txnDateError: error }) }}
        //
        description={this.state.description}
        onDescriptionChange={(event) => this.setState({ description: event.target.value })}
        descriptionError={this.state.descriptionError}
        setDescriptionError={(error) => { this.setState({ descriptionError: error }) }}
        //
        escrowBalance={this.state.escrowBalance}
        onEscrowBalanceChange={(event) => this.setState({ escrowBalance: event.target.value })}
        escrowBalanceError={this.state.escrowBalanceError}
        setEscrowBalanceError={(error) => { this.setState({ escrowBalanceError: error }) }}
        //
        dsraCurrent={this.state.dsraCurrent}
        onDsraCurrentChange={(event) => this.setState({ dsraCurrent: event.target.value })}
        dsraCurrentError={this.state.dsraCurrentError}
        setDsraCurrentError={(error) => { this.setState({ dsraCurrentError: error }) }}
        //
        dsraAmount={this.state.dsraAmount}
        onDsraAmountChange={(event) => this.setState({ dsraAmount: event.target.value })}
        dsraAmountError={this.state.dsraAmountError}
        setDsraAmountError={(error) => { this.setState({ dsraAmountError: error }) }}
        //
        osPrincipal={this.state.osPrincipal}
        onOsPrincipalChange={(event) => this.setState({ osPrincipal: event.target.value })}
        osPrincipalError={this.state.osPrincipalError}
        setOsPrincipalError={(error) => { this.setState({ osPrincipalError: error }) }}
        //
        osLoan={this.state.osLoan}
        onOsLoanChange={(event) => this.setState({ osLoan: event.target.value })}
        osLoanError={this.state.osLoanError}
        setOsLoanError={(error) => { this.setState({ osLoanError: error }) }}
        //
        osBalance={this.state.osBalance}
        onOsBalanceChange={(event) => this.setState({ osBalance: event.target.value })}
        osBalanceError={this.state.osBalanceError}
        setOsBalanceError={(error) => { this.setState({ osBalanceError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedTxn != this.props.selectedTxn)
      this.setState({ description: this.props.selectedTxn.description,
        dsraCurrent: this.props.selectedTxn.dsraCurrent,
        dsraAmount: this.props.selectedTxn.dsraAmount,
        osPrincipal: this.props.selectedTxn.osPrincipal,
        osLoan: this.props.selectedTxn.osLoan,
        osBalance: this.props.selectedTxn.osBalance
     })
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/accounts/${this.props.account.accountId}/reports/accountStatement/transactions/${this.props.selectedTxn.transactionId}/txnUpdate`,
      this.onSubmitCallback, {
        txnDate: this.state.txnDate,
      description: this.state.description,
      escrowBalanceF: this.state.escrowBalance,
      dsraCurrentF: this.state.dsraCurrent,
      dsraAmountF: this.state.dsraAmount,
      osPrincipalF: this.state.osPrincipal,
      osLoanF: this.state.osLoan,
      osBalanceF: this.state.osBalance
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(SoaTxnDescUpdateModalSF)
